import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from '@dropbox/dig-components/typography';
import { getBrandName } from 'js/sign-components/common/brand';

type Props = {
  tosUrl: string;
  privacyPolicyUrl: string;
  progressiveCheckoutTos?: boolean;
  isJoiningTeam?: boolean;
  isCreatePassword?: boolean;
  isUpdatePassword?: boolean;
};
export default function PrivacyTOSLinks({
  tosUrl,
  privacyPolicyUrl,
  isJoiningTeam = false,
  isCreatePassword = false,
  isUpdatePassword = false,
}: Props) {
  const siteName = getBrandName('S'); // TOS links should always use "Dropbox Sign" per legal

  if (isJoiningTeam) {
    return (
      <FormattedMessage
        id=""
        defaultMessage='By selecting "Agree and Join team" I agree to the <a1>{siteName} Terms</a1>. Learn about how we use and protect your data in our <a2>Privacy Policy</a2>.'
        description="Disclaimer text on join team page"
        values={{
          siteName,
          a1(chunks: any[]) {
            return (
              <Link href={tosUrl} target="_blank">
                {chunks}
              </Link>
            );
          },
          a2(chunks: any[]) {
            return (
              <Link href={privacyPolicyUrl} target="_blank">
                {chunks}
              </Link>
            );
          },
        }}
      />
    );
  }
  if (isCreatePassword) {
    return (
      <FormattedMessage
        id=""
        defaultMessage='By selecting "Agree and Create Password" I agree to the <a1>{siteName} Terms</a1>. Learn about how we use and protect your data in our <a2>Privacy Policy</a2>.'
        description="Disclaimer text on join team page"
        values={{
          siteName,
          a1(chunks: any[]) {
            return (
              <Link href={tosUrl} target="_blank">
                {chunks}
              </Link>
            );
          },
          a2(chunks: any[]) {
            return (
              <Link href={privacyPolicyUrl} target="_blank">
                {chunks}
              </Link>
            );
          },
        }}
      />
    );
  }
  if (isUpdatePassword) {
    return (
      <FormattedMessage
        id=""
        defaultMessage='By selecting "Agree and Update Password" I agree to the <a1>{siteName} Terms</a1>. Learn about how we use and protect your data in our <a2>Privacy Policy</a2>.'
        description="Disclaimer text on join team page"
        values={{
          siteName,
          a1(chunks: any[]) {
            return (
              <Link href={tosUrl} target="_blank">
                {chunks}
              </Link>
            );
          },
          a2(chunks: any[]) {
            return (
              <Link href={privacyPolicyUrl} target="_blank">
                {chunks}
              </Link>
            );
          },
        }}
      />
    );
  }
  return (
    <FormattedMessage
      id=""
      defaultMessage='By selecting "Agree and Sign up" I agree to the <a1>{siteName} Terms</a1>. Learn about how we use and protect your data in our <a2>Privacy Policy</a2>.'
      description="Disclaimer text on signup and login page"
      values={{
        siteName,
        a1(chunks: any[]) {
          return (
            <Link href={tosUrl} target="_blank">
              {chunks}
            </Link>
          );
        },
        a2(chunks: any[]) {
          return (
            <Link href={privacyPolicyUrl} target="_blank">
              {chunks}
            </Link>
          );
        },
      }}
    />
  );
}
